import { apiLogger } from '@hooks/use-logger';
import type { FetchBaseQueryArgs } from '@reduxjs/toolkit/query';
import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';
import type { RootState } from '@store/root-reducer';
import { setSessionHeaders } from '@utils/session';

const prepareHeaders: FetchBaseQueryArgs['prepareHeaders'] = async (headers) => {
    await setSessionHeaders(headers);
};

const baseQueryWithRetry = retry(fetchBaseQuery({ prepareHeaders }), {
    maxRetries: 0,
});

export const baseQueryWithInterceptorAndRetry: ReturnType<typeof fetchBaseQuery> = async (
    args,
    api,
    extraOptions,
) => {
    const result = await baseQueryWithRetry(args, api, extraOptions);

    if (result.error) {
        const state = api.getState() as RootState;

        await apiLogger(state, result);
    }

    return result;
};

export const publicApi = createApi({
    reducerPath: 'publicApi',
    baseQuery: baseQueryWithInterceptorAndRetry,
    tagTypes: [],
    endpoints: () => ({}),
});
